import { ActionContext, ActionTree } from 'vuex'
import { mutationType } from './mutation-types'
import CaregiverState, {ICaregiver, CaregiverList} from './states'
import _ from 'lodash'
import { State } from '@/store/store'
import axios from 'axios'
import HttpRequestServiceWithToken from '@/services/HttpRequestServiceWithToken'

const actions: ActionTree<CaregiverState, State> = {
  async getCaregiverList(
    { commit, dispatch, state }: ActionContext<CaregiverState, State>,
    options: object,
  ): Promise<void> {
    await HttpRequestServiceWithToken
    .getByLevel(process.env.VUE_APP_API_URL + '/v1', 'caregiver', options, (res: CaregiverList) => {
      commit(mutationType.GET_LISTS, res)
    })
  },
  async getCaregiverById(
    { commit, dispatch, state }: ActionContext<CaregiverState, State>,
    options: {[key: string]: any},
  ): Promise<void> {
    const id = options.id
    delete options.id
    await HttpRequestServiceWithToken
    .getByLevel(process.env.VUE_APP_API_URL + '/v1', `caregiver/${id}`, options, (res: ICaregiver) => {
      commit(mutationType.GET_BY_ID, res)
    })
  },
  async postCaregiver(
    { commit, dispatch, state }: ActionContext<CaregiverState, State>,
    options: object,
  ): Promise<void> {
    await HttpRequestServiceWithToken
    .postByLevel(process.env.VUE_APP_API_URL + '/v1', 'caregiver', options, (res: object) => {
      commit(mutationType.CREATE, res)
    })
  },
  async putCaregiver(
    { commit, dispatch, state }: ActionContext<CaregiverState, State>,
    options: {[key: string]: any},
  ): Promise<void> {
    const id = options.id
    delete options.id
    await HttpRequestServiceWithToken
    .putByLevel(
      process.env.VUE_APP_API_URL + '/v1', `caregiver/${id}`, options, (res: object) => {
      commit(mutationType.UPDATE, res)
    })
  },
  async deleteCaregiver(
    { commit, dispatch, state }: ActionContext<CaregiverState, State>,
    options: {[key: string]: any},
  ): Promise<void> {
    const id = options.id
    delete options.id
    await HttpRequestServiceWithToken
      .deleteByLevel(
        process.env.VUE_APP_API_URL + '/v1', `caregiver/${id}`, options, (res: object) => {
        commit(mutationType.DELETE, res)
      })
  },
  async getCountCaregiver(
    { commit, dispatch, state }: ActionContext<CaregiverState, State>,
    options: any,
  ): Promise<TCountCaregiver> {
    options.headers.excludeDate = Buffer.from(JSON.stringify(options.headers.excludeDate)).toString('base64')
    return await HttpRequestServiceWithToken
    .getByLevel(process.env.VUE_APP_API_URL + '/v1', 'caregiver/total', options, (res: TCountCaregiver) => {
      return res
    })
  },
}

export type TCountCaregiver = {total: number, banned: number, availableMax?: number}
export default actions
